import { Filter, PaginatedResponse } from '@libs/models/common';
import { request } from '../request';
import { filterToQueryParams } from '../utils/filterToQueryParams';
import { FacilityListItem } from '@libs/models/facilities';

type fetchAgenciesListParams = {
  search?: string;
  page?: number;
  size?: number;
  filters?: Filter[];
};
export async function fetchFacilitiesList(
  params?: fetchAgenciesListParams,
): Promise<PaginatedResponse<FacilityListItem[]>> {
  const filters = filterToQueryParams((params?.filters ?? []).map((fil) => ({ field: fil.key, value: fil.value })));

  const response = await request.get<PaginatedResponse<FacilityResponseItem[]>>('/facilities', {
    params: {
      pageNumber: params?.page || 1,
      pageSize: params?.size || 50,
      search: params?.search || undefined,
      ...filters,
    },
  });
  return {
    ...response.data,
    items: response.data.items.map((item) => ({
      ...item,
      address: {
        addressFirst: item.address.addressLine1,
        addressSecond: item.address.addressLine2,
        city: item.address.city,
        state: item.address.state,
        zipCode: item.address.zipCode,
      },
      linesOfBusiness: item.facilityTypes,
      status: item.status ?? 'Active',
    })),
  };
}

type FacilityResponseItem = {
  id: string;
  name: string;
  tenantId: string;
  createdOn: string;
  facilityTypes: string[];
  contact: {
    email: string;
    firstName: string;
    phoneNumber: string;
    lastName: string;
  };
  address: {
    addressLine1: string;
    addressLine2: string;
    city: string;
    state: string;
    zipCode: string;
  };
  status: 'Pending' | 'Disconnected' | 'Active' | 'OnReview' | 'Invited';
};
